// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service


//Models
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { NhaCungCapEditComponent } from 'app/views/pages/nfc/nha-cung-cap/nha-cung-cap-edit/nha-cung-cap-edit.component';
import { NhaCungCapModel } from 'app/views/pages/nfc/nha-cung-cap/nha-cung-cap-model/nha-cung-cap.model';
import { DungChungService } from 'app/views/pages/nfc/dung-chung/__services/dung-chung.service';
import { ThemMoiKHComponent } from 'app/views/pages/nfc/kinh-doanh/kd-yeu-cau-bao-gia/them-moi-kh/them-moi-kh.component';
import { AddDoiTuongComponent } from '../add-doi-tuong/add-doi-tuong.component';
import { HC_DangKyTiepKhachService } from '../../../hanh-chanh/hc-dang-ky-tiep-khach/hc-dang-ky-tiep-khach-service/hc-dang-ky-tiep-khach.service';
@Component({
  selector: 'kt-get-don-vi',
  templateUrl: './get-don-vi.component.html',
 
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetDonViComponent implements OnInit, OnDestroy  {

  /*Config Form */
	CONFIG: CommonConFig;
	// Public properties
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	isZoomSize: boolean = false;
	openDialog: boolean = false;
	private componentSubscriptions: Subscription;
	DVList: [];
	DonViForm: FormGroup;


	public datatree: BehaviorSubject<any[]> = new BehaviorSubject([]);
	listNV: BehaviorSubject<any[]> = new BehaviorSubject([]);

	constructor(
		public dialogRef: MatDialogRef<AddDoiTuongComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private DonViFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private changeDetect: ChangeDetectorRef,
		private dungChungService: DungChungService,
		private hc_dangkytiepkhachsService: HC_DangKyTiepKhachService,

	) { dialogRef.disableClose = true; }
	/**
	 * On init
	 */
	ngOnInit() {
		/*Load cấu hình config form */

		this.CONFIG = new CommonConFig();
		this.getTreeValue();
		this.createForm();
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		this.DonViForm = this.DonViFB.group({
			DonVi: [''],
		});
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		//if (this.VanPhongPham.Id_HH == 0) {
		return 'Chọn đơn vị';
		//}
		// return `Chỉnh sửa văn phòng phẩm - ${this.VanPhongPham.TenHH} `;
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */

	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	// onSubmit() {
	// 	// if (this.DonViForm.DonVi.value == undefined) {
	// 	// 	const message = `Đối tượng cần thêm chưa được chọn.`;
	// 	// 	this.layoutUtilsService.showInfo(message);
	// 	// }
	// 	// else{}
	// 	this.dialogRef.close({data:this.DVList});
	// 	console.log({data:this.DVList})
	// }
	async getTreeValue() {
		await this.hc_dangkytiepkhachsService.DM_PhongBan_Tree().subscribe(res => {
			if (res && res.status == 1)
				this.datatree.next(res.data);
			else
				this.datatree.next([]);
		});
	}

	GetValueNode(data) {
    this.dialogRef.close({id: data.Id_PB,ten: data.TenPB});
    // console.log({id: data.Id_PB,ten: data.TenPB})
	}


	// tslint:disable-next-line:prefer-const
	// 	let editedVanPhongPham = this.prepareVanPhongPhams();
	// 		if (this.VanPhongPham.Id_HH > 0) {
	// 			this.updateVanPhongPham(editedVanPhongPham)
	// 			return;
	// 		}
	// 	this.addVanPhongPham(editedVanPhongPham,type);
	// }
	/**
	 * Returns object for saving
	 */

	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog() {
		this.dialogRef.close(this.isChange);
	}

	forcusEvents() {
		this.openDialog = false;
		// if(this.focus != null && this.focus != undefined){
		// 	this.focus.first.nativeElement.focus();
		// }
		this.changeDetectView();
	}

	ValidateChangeNumberEvent(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == '.') {
					count += 1;
				}
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == '.') {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}
	resizeDialog() {
		if (!this.isZoomSize) {
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if (this.isZoomSize) {
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}
	}
	
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

}
